export const CRUD_DELETE = 'EPIC/CRUD_DELETE';
export const CRUD_DELETE_FAILURE = 'EPIC/CRUD_DELETE_FAILURE';
export const CRUD_DELETE_SUCCESS = 'APIC/CRUD_DELETE_SUCCESS';
